import { render, staticRenderFns } from "./uploadSourceMore.vue?vue&type=template&id=522295d6&scoped=true"
import script from "./uploadSourceMore.vue?vue&type=script&lang=js"
export * from "./uploadSourceMore.vue?vue&type=script&lang=js"
import style0 from "./uploadSourceMore.vue?vue&type=style&index=0&id=522295d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522295d6",
  null
  
)

export default component.exports